import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { LanguageProvider } from './i18n/LanguageContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import History from './pages/History';
import Leadership from './pages/Leadership';
import Capabilities from './pages/Capabilities';
import Strategy from './pages/Strategy';
import Projects from './pages/Projects';
import GlobalPresence from './pages/GlobalPresence';
import Partnerships from './pages/Partnerships';
import Contact from './pages/Contact';
import './App.css';

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [pathname]);
    return null;
};

function App() {
    return (
        <LanguageProvider>
            <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/history" element={<History />} />
                        <Route path="/leadership" element={<Leadership />} />
                        <Route path="/capabilities" element={<Capabilities />} />
                        <Route path="/strategy" element={<Strategy />} />
                        <Route path="/projects" element={<Projects />} />
                        <Route path="/global-presence" element={<GlobalPresence />} />
                        <Route path="/partnerships" element={<Partnerships />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="*" element={<Home />} />
                    </Route>
                </Routes>
            </BrowserRouter>
            <Toaster richColors position="top-right" />
        </LanguageProvider>
    );
}

export default App;
